import { TrendingMenu } from '@/components/TrendingMenu';
import { LabradorComponent } from '@/types/component';

export const LabradorTrendingMenu: LabradorComponent = ({ type, data, meta, descendants, ...props }) => {
  return <TrendingMenu tags={data.tags} headline={data.headline} {...props} />;
};
